// language-select.component.ts
import { Component, ElementRef, OnInit } from '@angular/core';
import { UserData } from '../interfaces/user-data';
import { LanguageStorageService } from './languageStorage.service';
import './languageSelector.component.css'; // Remove this line as styles are added below
import { LanguageService } from './language.service';
import { AppStateService } from '../appState.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-language-select',
  template: `
    <div *ngIf="translatorAvailable" class="language-selector-container">
      <select [(ngModel)]="selectedLanguage" (change)="languageChanged()" [disabled]="isLoading">
        <option *ngFor="let language of languages" [value]="language.key">
          {{ language.value }}
        </option>
      </select>
      
      <div *ngIf="isLoading" class="spinner"></div>
    </div>
  `,
  styleUrls: ['./languageSelector.component.css'],
})
export class LanguageSelectComponent implements OnInit {
  public translatorAvailable = true;
  public isLoading = false;

  selectedLanguage: string = 'en-US';
  languages;

  constructor(
    private languageStorage: LanguageStorageService,
    private languageService: LanguageService,
    private elementRef: ElementRef,
    private appState: AppStateService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    // Check for Translator API availability
    this.translatorAvailable = true; //!!((window as any).Translator && typeof (window as any).Translator.create === 'function');
    this.detectBrowserLanguage();

    this.languages = this.languageService.langs;
    console.log('Available languages:', this.languages);

    this.route.params.subscribe(params => {
      const mapKey = params['id'];
      console.log('Map Key:', mapKey, params);
    });
  }

  detectBrowserLanguage() {
    const 
      storedLanguage = this.languageStorage.getLanguage()
    ;
    if (storedLanguage && this.languageService.languages[storedLanguage]) {
      this.selectedLanguage = storedLanguage;
      return;
    }

    let browserLanguage = navigator.language;
    if (this.languageService.languages[browserLanguage]) {
      this.selectedLanguage = browserLanguage;
    } 
    else {
      const langWithoutRegion = browserLanguage.split('-')[0];
      if (this.languageService.languages[langWithoutRegion]) {
        this.selectedLanguage = langWithoutRegion;
      } 
      else {
        this.languageService.languages[browserLanguage] = browserLanguage;
        this.selectedLanguage = browserLanguage;
      }
    }
  }

  async ngAfterViewInit() {
    const hostElement = this.elementRef.nativeElement,
          parentAttribute = hostElement.hasAttribute('absolute')
    ;

    if (parentAttribute) {
      hostElement.classList.add('absolute');
    }
  }

  // --- METHOD MODIFIED ---
  async languageChanged() {
    console.log('Language changed to:', this.selectedLanguage, this.checkCurrentMap());

    // 1. Show the spinner
    // this.isLoading = true;

    let langchg = await this.languageService.setLanguage(this.selectedLanguage);
    console.log("Lang changed:", langchg);
    // debugger;
    // window.location.reload(); // Reload the page to apply the new language
    // if( this.checkCurrentMap() ) {
    // }
    // else {
      // this.languageService.load(this.selectedLanguage);
    // }
    (window as any).location.reload();
  }

  public checkCurrentMap(): boolean {
    return /\/map\//.test(window.location.href);
  }
}